import React from "react";
import { ReceiptDetailData, ReceiptHistoryItem } from "../lib/api";

type BadgeInfo = { label: string; className: string };

export function getReceiptStatusBadge(item: Pick<ReceiptDetailData | ReceiptHistoryItem, "relayStatus" | "needsReview">): BadgeInfo {
  if (item.relayStatus === "failed") {
    return { label: "エラー", className: "bg-red-100 text-red-700" };
  }
  if (item.relayStatus === "accepted") {
    return { label: "処理中", className: "bg-gray-100 text-gray-600" };
  }
  if (item.needsReview) {
    return { label: "要確認", className: "bg-orange-100 text-orange-700" };
  }
  return { label: "確認済", className: "bg-green-100 text-green-700" };
}

type Props = {
  item: Pick<ReceiptDetailData | ReceiptHistoryItem, "relayStatus" | "needsReview">;
};

export function ReceiptStatusBadge({ item }: Props) {
  const { label, className } = getReceiptStatusBadge(item);
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-bold ${className}`}>
      {label}
    </span>
  );
}
